import { LocalStorageKeys, useLocalStorage } from '@web/hooks/useLocalStorage';

import { type VideoProgressStorage } from '../VideoPlayer.types';

export const useVideoProgress = (videoID: string, initialValue: 0): [number, (progress: number) => void] => {
    const [storage, setStorage] = useLocalStorage<VideoProgressStorage>(
        LocalStorageKeys.VIDEOPLAYER_PROGRESS,
        {},
    );
    const progress = storage?.[videoID] || initialValue;
    const setProgress = (progress: number) => {
        storage[`${videoID}`] = progress;
        setStorage(storage);
    };
    return [progress, setProgress];
};
